import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";
import React from "react";
import Label from "./LabelF";
import { esMinuscula } from "../../../helper/funciones";

const InputCheckbox = ({ setValor, valor, cab, error, setError, data }) => {
  const {
    label,
    textAlign,
    width,
    margin,
    padding,
    // filtrosAAplicar,
    // setFiltrosAAplicar,
    opcionales_null,
    permite_null,
    id_a,
    grid_span,
    nombre
  } = cab;

  let s = "s";
  let n = "n";

  if (valor) {
    s = esMinuscula(valor.toString()) ? "s" : "S";
    n = esMinuscula(valor.toString()) ? "n" : "N";
  }

  const tieneError = Boolean(error?.[id_a]);

  const onChange = (e) => {
    setValor(e.target.checked ? s : n);
    setError((prev) => {
      const ne = { ...prev };
      ne[id_a] = false;
      return ne;
    });
  };

  const styles = {
    textAlign,
    width,
    margin,
    padding,
    gridColumn: grid_span,
  };

  return (
    <div style={styles}>
      <FormControl fullWidth error={tieneError}>
        <Label
          label={nombre}
          opcionales_null={opcionales_null}
          permite_null={permite_null}
        />
        <FormControlLabel
          control={
            <Checkbox
              onChange={onChange}
              checked={valor?.toString() === s?.toString()}
            />
          }
          label={label}
          sx={{
            width: "100%",
            boxSizing: "border-box",
            border: "1px solid",
            borderColor: tieneError ? "error.main" : "transparent",
            borderRadius: "4px",
            padding: "4px 8px",
            marginLeft: "0px",
          }}
        />

        {tieneError && (
          <FormHelperText>Debe seleccionar una opción.</FormHelperText>
        )}
      </FormControl>
    </div>
  );
};

export default InputCheckbox;
